export default __webpack_public_path__ + "static/media/2004.ffa0cf84.png";